import api from './api';

/**
 * Service for fetching progress reports from the API
 */
export const progressReportService = {
  /**
   * Get overall progress report for all customers
   * @returns Promise with the overall progress report data
   */
  getOverallProgressReport: async () => {
    try {
      const response = await api.get('/reports/progress');
      return response.data;
    } catch (error) {
      console.error('Error fetching overall progress report:', error);
      throw error;
    }
  },

  /**
   * Get progress report for a specific customer
   * @param customerId The ID of the customer to get the report for
   * @returns Promise with the customer progress report data
   */
  getCustomerProgressReport: async (customerId: string) => {
    try {
      const response = await api.get(`/reports/progress/customer/${customerId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching progress report for customer ${customerId}:`, error);
      throw error;
    }
  },

  /**
   * Send progress report via email
   * @param email Email address to send the report to
   * @param type Type of report to send (overall or customer)
   * @param customerId Customer ID (required for customer reports)
   * @returns Promise with the result of the operation
   */
  sendProgressReport: async (email: string, type: 'overall' | 'customer', customerId?: string) => {
    try {
      const payload: any = { email, type };
      
      if (type === 'customer' && !customerId) {
        throw new Error('Customer ID is required for customer reports');
      }
      
      if (type === 'customer') {
        payload.customerId = customerId;
      }
      
      const response = await api.post('/reports/send', payload);
      return response.data;
    } catch (error) {
      console.error('Error sending progress report:', error);
      throw error;
    }
  },

  /**
   * Queue progress reports for sending
   * @param force Whether to force sending even if it's not the scheduled time
   * @returns Promise with the result of the operation
   */
  queueProgressReports: async (force: boolean = false) => {
    try {
      const response = await api.post('/reports/progress', { force });
      return response.data;
    } catch (error) {
      console.error('Error queuing progress reports:', error);
      throw error;
    }
  }
};

export default progressReportService;
